import { Badge } from "@mantine/core";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import { useHasPermission } from "../../hooks/useHasPermission";

interface HeldForReviewDeliveryBadgeProps {
  heldEmailId: string;
}

function useHeldEmailDestination(heldEmailId: string): string {
  return useMemo(
    () =>
      `/admin/system-emails?tab=queue&heldEmailId=${encodeURIComponent(
        heldEmailId
      )}`,
    [heldEmailId]
  );
}

export function HeldForReviewDeliveryBadge({
  heldEmailId,
}: HeldForReviewDeliveryBadgeProps) {
  const canReadSystemEmails = useHasPermission("system_emails.read");
  const destination = useHeldEmailDestination(heldEmailId);

  if (!canReadSystemEmails) {
    return (
      <Badge color="orange" variant="light">
        Email held
      </Badge>
    );
  }

  return (
    <Badge component={Link} color="orange" to={destination} variant="light">
      Email held
    </Badge>
  );
}
